exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body h1[data-v-7d5cf11b]{margin-top:0!important}.no-logo[data-v-7d5cf11b]{position:relative}.no-logo img[data-v-7d5cf11b]{height:300px;width:100%}.no-logo h4[data-v-7d5cf11b]{position:absolute;top:35%;text-align:center;width:100%;color:#057aff;font-size:70px;text-shadow:2px 8px 8px hsla(0,0%,83%,.5),2px -6px 25px #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d5cf11b","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/catalog/gym/view.vue
// module id = qs88
// module chunks = 0